import { useMutation, useQuery } from '@tanstack/react-query';
import {
  commonAxiosError,
  commonAxiosSuccess,
} from '../../../Utils/TanstackQuery/queryClient';
import { httpService } from '../../../Helpers/Fetcher/axios';
import Toaster from '../../../Components/Toaster/Toaster';
import { eventApi } from './constantEvent';
import { EventList, ISingleEvent } from './eventType';

const Toast = Toaster();
export const useRegisteredSingleEventB2B = () => {
  return useMutation({
    mutationFn: (data: { fair_event_id: number }) =>
      httpService.post({ url: `${eventApi.BOOK_SINGLE_EVENT_FOR_B2B}`, data }),
    onSuccess: () => {
      commonAxiosSuccess();

      //   queryClient.invalidateQueries({
      //     // queryKey: [eventApi.GET_VISITOR_EVENT],
      //   });
    },

    onError: (err) => {
      Toast.fire({
        icon: 'error',
        title: `Something went wrong`,
      });
    },
  });
};
export const useRegisteredSingleEventVisitor = () => {
  return useMutation({
    mutationFn: (data: { fair_event_id: number }) =>
      httpService.post({
        url: `${eventApi.BOOK_SINGLE_EVENT_FOR_VISITOR}`,
        data,
      }),
    onSuccess: () => {
      commonAxiosSuccess();
      // queryClient.invalidateQueries({
      //   queryKey: [eventApi.GET_VISITOR_EVENT],
      // });
    },
    onError: commonAxiosError(),
  });
};

export const useGetEventList = (name: string) => {
  return useQuery({
    queryKey: [eventApi.GET_ALL_EVENT_LIST, name],
    queryFn: () =>
      httpService.get<EventList[]>({
        url: eventApi.GET_ALL_EVENT_LIST,
        params: { name },
      }),
  });
};
export const useGetSingelEventDetails = (id: number) => {
  return useQuery({
    queryKey: [eventApi.GET_SINGLE_EVENT_BY_EVENT_ID(id)],
    queryFn: () =>
      httpService.get<ISingleEvent>({
        url: eventApi.GET_SINGLE_EVENT_BY_EVENT_ID(id),
      }),
  });
};
